import { useEffect, useState } from "react";
import { RouteHttpVerb, RouteParamsInterface, RouteRequestInterface } from "@tatum/utils";
import { showError } from "../utils/message";
import { ResponseError } from "../models/reponseError";
import { request } from "../utils";

export const useGet = <T extends ResponseError>(path: string, options?: Options) => {
    const [data, setData] = useState<T | null>(null);
    const fetchMyAPI = async () => {
        try {
            const result = await request<RouteRequestInterface, RouteParamsInterface, T>({
                location: {
                    path,
                    method: RouteHttpVerb.GET
                },
                options
            });

            if (result?.status === "error" && result.message) {
                showError(result.message);
            }

            setData(result);
        } catch (e) {
            showError("An error occurred. Please contact support.");
        }
    };
    useEffect(() => {
        if (options?.lazy !== true) {
            fetchMyAPI();
        }
    }, []);

    return { data, refetch: fetchMyAPI };
};

export interface Options {
    restRoot: string;
    restNamespace: string;
    restNonce?: string;
    restQuery?: string;
    lazy?: boolean;
}
